import type { ComponentProps } from 'react';

import { type VariantProps } from 'class-variance-authority';

import { badgeVariants } from '@shared/components/variants/badge.variants';
import { cn } from '@shared/utils';

interface BadgeProps extends ComponentProps<'div'>, VariantProps<typeof badgeVariants> {}

export const Badge = ({ className, variant, ...props }: BadgeProps) => {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
};
